import { TextInput, TextInputProps } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import JpgResponseCodeDrawerButton from './JpgResponseCodeDrawerButton';

interface JpgResponseCodeInputProps extends TextInputProps {
}

const JpgResponseCodeInput = ({ formElements, source, fields, ...props }: JpgResponseCodeInputProps) => {
  const { getValues } = useFormContext();
  const valueKey = source;
  const values = getValues();

  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <TextInput fullWidth source={source} />
      <JpgResponseCodeDrawerButton id={values[valueKey]} />
    </div>
  );
};

JpgResponseCodeInput.defaultProps = {
}

export default JpgResponseCodeInput;
